const sentUniqueEvents = new Set()
export function track(eventName, unique = true) {
  if (unique && sentUniqueEvents.has(eventName)) {
    return
  }

  sentUniqueEvents.add(eventName)
  if (window.fbq) {
    window.fbq('trackCustom', eventName)
  }

  if (
    !sentUniqueEvents.has('triedAllTheButtons') &&
    sentUniqueEvents.has('layoutChanged') &&
    sentUniqueEvents.has('dedicationChanged')
  ) {
    track('triedAllTheButtons')
  }
}

export function trackProblemEvent(action, label){
   if (window.gtag){
     // eslint-disable-next-line no-undef
     window.gtag('event', action, {
      event_category: 'problem',
      event_label: label,
    })
   }
   else {
     console.log(`gtag not found, trackProblem: ${action}, ${label}`)
   }
   
}